import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AuditLogFilterApiModel,
  AuditLogsApiModel,
  AuditLogSelectorsDateRangeApiModel,
  AuditLogsFilterSelectorsApiModel
} from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class AuditLogsService {
  public apiUrl = 'audit-logs';

  constructor(private http: HttpClientService) {}

  public getList(filters: AuditLogFilterApiModel): Observable<AuditLogsApiModel> {
    return this.http.post<AuditLogsApiModel>(`${this.apiUrl}/get-list`, filters);
  }

  public getFilterSelectors(
    dateRange: AuditLogSelectorsDateRangeApiModel
  ): Observable<AuditLogsFilterSelectorsApiModel> {
    return this.http.post<AuditLogsFilterSelectorsApiModel>(`${this.apiUrl}/get-filter-selectors`, dateRange);
  }

  public exportToXlsx(filters: AuditLogFilterApiModel): Observable<any> {
    return this.http.post(`${this.apiUrl}/export-xlsx`, filters, { responseType: 'blob', observe: 'response' });
  }
}
